import { NfcCardBalance, fetchCardBalance } from 'lib/models/nfcCards';
import { useCallback, useEffect, useState } from 'react';

/**
 * The balance of a card. `setBalance` takes the one a load or a reset answered with, so the
 * panel shows it without reading it again.
 */
function useNfcCardBalance(cardId: string) {
	const [loading, setLoading] = useState<boolean>(false);

	const [balance, setBalance] = useState<NfcCardBalance | null>(null);

	const [failed, setFailed] = useState<boolean>(false);

	const refetch = useCallback(async () => {
		setLoading(true);
		const response = await fetchCardBalance(cardId);
		setBalance(response);
		setFailed(!response);
		setLoading(false);
	}, [cardId]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, balance, failed, refetch, setBalance };
}

export default useNfcCardBalance;
